// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6ff54a63","879":"215affb1"}[chunkId] + ".chunk.js";
};